/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_8019
 */

import { message } from 'ant-design-vue'
import {
  redirectUrl_delete_post,
  redirectUrl_downloadTemplate_post,
  redirectUrl_exportData_post,
  redirectUrl_importData_post,
  redirectUrl_listByCondition_post,
  redirectUrl_save_post
} from 'server/modules/8019'

// 删除重定向设置
export const redirectUrl_delete_post_ = async function(params, initList) {
  const { success, retInfo } = await redirectUrl_delete_post(params)
  if (success) {
    initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 下载模板
export const redirectUrl_downloadTemplate_post_ = async function(params) {
  const { success, data, retInfo } = await redirectUrl_downloadTemplate_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 导出数据
export const redirectUrl_exportData_post_ = async function(params) {
  const { success, retInfo } = await redirectUrl_exportData_post(params)
  if (success) {
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 导入数据
export const redirectUrl_importData_post_ = async function(params) {
  const { success, data, retInfo } = await redirectUrl_importData_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询重定向设置
export const redirectUrl_listByCondition_post_ = async function(params, state) {
  const { success, data, retInfo } = await redirectUrl_listByCondition_post(
    params
  )
  if (success) {
    state.dataSource = [...data.list]
    state.pagination.total = data.total
  } else {
    message.error(retInfo)
  }
}

// 新增/编辑重定向设置
export const redirectUrl_save_post_ = async function(params, state) {
  const { success, retInfo } = await redirectUrl_save_post(params)
  if (success) {
    state.initList()
    message.success(retInfo)
    state.visibleChange(false)
  } else {
    message.error(retInfo)
  }
}
